var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.9516 4 4 12.9516 4 24C4 35.0484 12.9516 44 24 44C35.0484 44 44 35.0484 44 24C44 12.9516 35.0484 4 24 4ZM31.4589 29.2419L29.846 31.2581C29.7401 31.3904 29.6092 31.5006 29.4608 31.5823C29.3124 31.6641 29.1493 31.7158 28.9809 31.7345C28.8125 31.7532 28.642 31.7386 28.4792 31.6915C28.3165 31.6443 28.1646 31.5655 28.0323 31.4597L22.629 27.45C22.2515 27.1477 21.9468 26.7644 21.7374 26.3285C21.528 25.8925 21.4193 25.4151 21.4194 24.9314L21.4194 12.3871C21.4194 12.0449 21.5553 11.7167 21.7973 11.4747C22.0393 11.2327 22.3675 11.0968 22.7097 11.0968H25.2903C25.6325 11.0968 25.9607 11.2327 26.2027 11.4747C26.4447 11.7167 26.5806 12.0449 26.5806 12.3871L26.5806 24L31.2581 27.4274C31.3905 27.5333 31.5007 27.6643 31.5824 27.8128C31.6642 27.9614 31.7159 28.1245 31.7345 28.2931C31.7531 28.4616 31.7384 28.6321 31.6911 28.7949C31.6438 28.9577 31.5649 29.1096 31.4589 29.2419Z",
    fill: "#5D5D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.8330a708793bd75c709df6b94e449990.svg";
export { ForwardRef as ReactComponent };